import { DataField } from "./DataField";
import { ListDataFieldOption } from "./ListDataFieldOption";

export class ListDataField extends DataField {
	public static readonly $type: string = "ListDataField";
	public readonly $type: string = ListDataField.$type;

	public defaultOption?: ListDataFieldOption;
	public options: ListDataFieldOption[] = [];
}
